export default __webpack_public_path__ + "static/media/8.40d12672.png";